import { AiOutlineCloseCircle, AiOutlineMail } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { UserInfo } from "../../models/user-info";
import PushNotificationFormStep1 from "./PushNotificationForm.Step1";
import PushNotificationFormStep2 from "./PushNotificationForm.Step2";
import PushNotificationFormStep3 from "./PushNotificationForm.Step3";
import { PushNotificationFormValues } from "./PushNotificationForm.Types";

interface PushNotificationProps {
  setLoading: (loading: boolean) => void;
  setShowThankYou: (showThankYou: boolean) => void;
  userInfo: UserInfo;
  setValue: any;
  formValues: PushNotificationFormValues;
  setCurrentStep: (step: number) => void;
  currentStep: number;
  handleSubmit: any;
  onSubmit: () => void;
  control: any;
  notificationType: string;
}

const PushNotificationForm = ({
  setLoading,
  setValue,
  formValues,
  setCurrentStep,
  currentStep,
  handleSubmit,
  onSubmit,
  control,
  notificationType,
}: PushNotificationProps) => {
  const navigate = useNavigate();

  const goBack = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <div className="flex flex-col pt-8 px-10 pb-20">
      {/* Header */}
      <div className="mb-8 w-full ">
        <div className="flex items-center justify-between mb-5">
          <div className="flex items-center gap-4">
            <span className="text-[#00000040]">
              <AiOutlineMail className="w-4 h-4" />
            </span>
            <h4 className="font-semibold text-gray-700">Send a Notification</h4>
          </div>
          <span className="text-[#00000040]">
            <AiOutlineCloseCircle
              className="w-8 h-8"
              onClick={() => navigate("/dashboard")}
              role="button"
              tabIndex={0}
            />
          </span>
        </div>

        {/* Progress Bar */}
        <div className="w-full bg-gray-200 h-4 rounded-full relative">
          <div
            className={`
                ${currentStep === 1 ? "w-1/3" : ""}
                ${currentStep === 2 ? "w-2/3" : ""}
                ${currentStep === 3 ? "w-full" : ""}
                `}
          >
            <div
              className="bg-[#424242] h-4 rounded-full grid"
              style={{
                width:
                  currentStep === 1
                    ? "50%"
                    : currentStep === 2
                    ? "75%"
                    : "83.3%",
              }}
            >
              <div
                className="rounded-full bg-white w-3 h-3 justify-self-end"
                style={{
                  marginRight: "2px",
                  marginTop: "2px",
                }}
              ></div>
            </div>
          </div>

          <div className="flex justify-between text-sm mt-2">
            <span className="w-1/3 text-center">Type</span>
            <span className="w-1/3 text-center">Content</span>
            <span className="w-1/3 text-center">Schedule</span>
          </div>
        </div>

        {/* Steps */}
      </div>

      {/* Form */}
      <form onSubmit={handleSubmit(onSubmit)} className="mt-8">
        {
          // Step 1
          currentStep === 1 && (
            <PushNotificationFormStep1
              control={control}
              formValues={formValues}
              selectedNotificationType={notificationType}
            />
          )
        }
        {
          // Step 2
          currentStep === 2 && (
            <PushNotificationFormStep2
              control={control}
              formValues={formValues}
              goBack={goBack}
            />
          )
        }
        {
          // Step 3
          currentStep === 3 && (
            <PushNotificationFormStep3
              control={control}
              formValues={formValues}
              goBack={goBack}
            />
          )
        }
      </form>
    </div>
  );
};

export default PushNotificationForm;
